<div role="main">
  <div *ngIf="!fromexternalauth" class="row justify-content-center login-container">
    <div class="col-sm-12 col-md-12 col-lg-6 login-form-left">
      <h3><a routerLink="/access/login" [attr.aria-label]="language.loginHomepage">Web Test</a></h3>
      <div class="login-pic-wrap">
        <!-- <img src="/assets/images/login-pic.png" width="300" alt="login pic" /> -->
        <img *ngIf="this.util.getSubdomain() && logourl" [src]="logourl" width="300" [alt]="language.webtestLoginPic" />
      </div>
    </div>
    <div class="col-sm-12 col-md-12 col-lg-6 login-form-right">
      <!-- <p class="about-btn">
      <a href="https://webtest.ng" target="_blank">about us</a>
    </p> -->
      <div class="card bg-secondary col-sm-10 col-sm-offset-1 mx-auto" aria-labelledby="loginTitle">
        <div class="card-body px-lg-3 py-lg-3">
          <div class="alert center" style="padding: 0.75em 0; text-align: center;"  role="status" aria-live="polite" >
            <p class="font-weight-bold" *ngIf="isLoading" style="color:white; background-color: cornflowerblue;">
              <!-- <span><img style="height:40px;" src="/assets/img/spinner.gif" aria-hidden="true"/></span> -->
               <span><app-loading-spinner [width]="40" [height]="40"></app-loading-spinner></span>
            </p>
          </div>
          <!-- <div class="login-mobile-logo">
          <h3>Web Test</h3>
        </div> -->
          <div class="welcome-users" style="max-height: 300px !important;">
            <div class="unique-company-logo">
              <img *ngIf="this.util.getSubdomain() && logourl" [src]="logourl" width="300" style="max-width: 50%;max-height: 90% !important;"
                 [alt]="language.companyBadgePic" />
            </div>
            <p *ngIf="!externaltoken">{{language.login}}</p>
          </div>
          <form #login="ngForm" name="login" (ngSubmit)="loginclicked()" style="border: 0px !important;"
            class="login-form" [attr.aria-labelledby]="'loginTitle'">
            <div *ngIf="!externaltoken">
              <div class="form-group">
                <label class="form-control-label" for="usernameInput">{{language.username}}</label>
                <input class="form-control" placeholder="Enter username here" required type="text" name="user"
                  [(ngModel)]="username"  id="usernameInput" autofocus>
              </div>
              <div class="form-group">
                <label class="form-control-label" for="passwordInput">{{language.password}}</label>
                <div id="passwordDiv">
                  <input class="form-control" placeholder="Enter password here" type="password" required name="password" [type]="showPassword ? 'text' : 'password'"
                    [(ngModel)]="password" id="passwordInput">
                  <button type="button" (click)="togglePasswordVisibility()" class="h-100 form-control" id="togglePasswordVisibilityButton">
                    <i class="fa" [ngClass]="{'fa-eye': !showPassword, 'fa-eye-slash': showPassword}"></i>
                  </button>
                </div>
              </div>
              <div class="text-center">
                <button type="submit" class="btn btn-primary my-4 form-control"
                  [disabled]="login.invalid || isLoading" [attr.aria-label]="language.submitLoginForm">
                  {{language.login}}
                </button>
              </div>

            </div>
            <div *ngIf="externaltoken">
              <button type="submit" class="btn btn-primary my-4 form-control" [disabled]="isLoading" [attr.aria-label]="language.clickToLogin" autofocus>Enter</button>
            </div>
            <div class="d-flex justify-content-between" role="navigation" [attr.aria-label]="language.helpfulLinks">

               <a class="complaint" routerLink="/system-check">{{language.systemCheck}} </a>
               <a class="complaint" routerLink="/complaint"> {{language.makeComplaint}} </a>
            </div>
          </form>
        </div>
      </div>

    <!-- <p class="web-test-btn">
      <a href="https://webtest.ng" class="nav-link" target="_blank">web test</a>
    </p> -->
    </div>
  </div>
  <div *ngIf="fromexternalauth" class="logged-out-message" role="alert" aria-live="polite">
    {{language.loggedOut}}
  </div>
</div>
<div *ngIf="!this.seb" class="webtest-link" role="contentinfo">
  <!--In SEB, we don't want any external links-->
    <div class="copyright-text">
      <p>© 2025 <a href="https://webtest.ng" target="_blank" rel="noopener noreferrer" [attr.aria-label]="language.visitWebtestWebsite">webtest.ng</a> All rights reserved.</p>
    </div>
  
</div>
<div class="sr-only" aria-live="assertive">
  {{ isLoading ? language.loadingWait : '' }}
</div>